/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaNotifications from 'DesignSystem/Svgs/TysiaNotifications/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Medical/Content/Content/Categories/Category/Questions/Question/Actions/AlertAction/Content"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let questionAlertValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'alert',
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
 paddingBottom={0}
 paddingTop={0}
 paddingLeft={0}
 paddingRight={0}
>
{childProps => (
<TysiaNotifications
{...childProps}
  viewPath={`${viewPath}/TysiaNotifications`}
 width={16}
 height={16}
 stroke={questionAlertValueData ? dtColorsOrange400 : dtColorsNeutral400}
 fill={questionAlertValueData ? dtColorsOrange400 : dtColorsNeutral400}
 data="question.alert"
/>
)}
</TysiaButtonIcon>
</button>
{children}
</React.Fragment>)
}